import {ANALYZERS_ROUTES} from "@constants"
import {offices, reports, repricingPass, searchID, userData} from "@signals"
import PageWrapper from "Pages/@PageWrapper"
import {resetCustomFilters, responseData} from "Pages/AnalyzersV2/@signals"
import DorContent from "Pages/AnalyzersV2/Dor/Content"
import DorFilters from "Pages/AnalyzersV2/Dor/Filters"
import React, {useEffect, useState} from "react"
import {createPortal} from "react-dom"
import {useSearchParams, useLocation} from "react-router-dom"
import {Box, Skeleton, Typography} from "@mui/material";
import {AppOfficesBlock} from "../../../@components";
import PageWrapperAnalyzers from "../../@PageWrapper/Actions/Analyzers";
import ReportsAutocomplete from "../../@PageWrapper/Actions/Reports";
import ExecutionField from "../../@PageWrapper/Actions/ExecutionField";
import {useSearchDate} from "../@hooks";
import VirtualTourButton, {TourOverlay, TOUR_STEPS} from "./VirtualTour";
import DorDemoData from "./VirtualTour/DemoData";
import { AnalyzerEvolutionModal } from "Pages/AnalyzersV2/@components";
import { demoPopoverOpen } from "./VirtualTour/signals";
import { dsColorNew } from "@palette"


export default function DorAnalyzer() {
	const [ searchParams ] = useSearchParams()
	const location = useLocation()
	const { date, office, isLoading } = useSearchDate()
	const [tourActive, setTourActive] = useState(false)

	useEffect(() => {
		resetCustomFilters()
		searchID.value = searchParams.get("idSearch")
		reports.value = searchParams.get("idReportExecution")
		// a repricing pass (CU-869fmm944): read like a report execution, never into `reports`
		repricingPass.value = searchParams.get("idRepricingExecution")
		offices.value = searchParams.get("idOfficePickup")
	}, [location.search])

	return <PageWrapper
		head={`DS Rentacar | ${ANALYZERS_ROUTES.DOR_SUBTITLE}`}
		title={ANALYZERS_ROUTES.TITLE}
		subtitle={ANALYZERS_ROUTES.DOR_SUBTITLE}
		isEmpty={false}
		showAnalyzersLinks={true}
		filters={<DorFilters/>}
		actions={<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, whiteSpace: 'nowrap' }}>
			{!searchID.value && <Box data-tour-id="tour-report-selector" sx={{ minWidth: { xs: 240, xl: 300 }, mr: { xs: 0.5, xl: 2 } }}>
				{/* with DS Repricing the field has the kinds Reports · Repricing; without it, the field of before (decision 1) */}
				{userData.value?.featuresV2?.ds_repricing ? <ExecutionField/> : <ReportsAutocomplete/>}
			</Box>}
			{!!searchID.value && <>
				{isLoading
					? <Skeleton variant='rounded' height={30} sx={{ borderRadius: '8px' }}/>
					: <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: 1, color: 'secondary.main' }}>
						<AppOfficesBlock sx={{ color: dsColorNew.black }} {...office}  /> -
						<Typography variant="subtitle2" fontWeight='regular'>{date}</Typography>
					</Box>}
			</>}
			<PageWrapperAnalyzers/>
			<VirtualTourButton onClick={() => setTourActive(true)} />
		</Box>}
	>
		<DorContent/>
		{tourActive && !Object.keys(responseData.value || {}).length && <DorDemoData/>}
		{tourActive && !Object.keys(responseData.value || {}).length && <AnalyzerEvolutionModal/>}
		{tourActive && createPortal(
			<TourOverlay steps={TOUR_STEPS} onClose={() => {
				demoPopoverOpen.value = false
				setTourActive(false)
			}} />,
			document.body
		)}
	</PageWrapper>
}
